import React from "react";
import PropTypes from "prop-types";
import Circle from "@mui/icons-material/Circle"; // Import the Circle icon

const getColor = (status) => {
  switch (status.toLowerCase()) {
    case "success":
      return "#6ACE7F";
    case "error":
      return "#F40000";
    case "inprocess":
      return "#F79900";
    case "partialsuccess":
      return "#6AC9CE";
    default:
      return "#B0B0B0";
  }
};

const StatusChip = ({ status }) => {
  const color = getColor(status);

  const chipStyle = {
    display: "flex",
    alignItems: "center",
    gap: "2px", // Space between the circle and text
    color: "black", // Text color
  };

  return (
    <div style={chipStyle}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "2px solid gray", // Grey outer layer
          borderRadius: "50%", // Make it circular
          padding: "1px", // Space around the circle
        }}
      >
        <Circle style={{ color: color, fontSize: "17px" }} /> {/* Round color */}
      </div>
      {status}
    </div>
  );
};

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusChip;